// NEEDS分類取得（大）
export const PAGE_INIT = "search/classification/PAGE_INIT";
// NEEDS分類取得（中）
export const NEEDS_MST_M_GET = "search/classification/NEEDS_MST_M_GET";
// NEEDS分類取得（小）
export const NEEDS_MST_S_GET = "search/classification/NEEDS_MST_S_GET";
// 選択した小分類に所属する企業一覧の取得
export const CORP_GET = "search/classification/CORP_GET";
